module.exports = __webpack_public_path__ + "d46ef15796e15418b59f93bb2cfe5da8.svg";